import React, { Component } from 'react'
import Counter from './Counter';
import './Demo.css';
import ToggleBtn from './ToggleBtn';
import PowerPlugin from './PowerPlugin/PowerPlugin';
import AxiosList from './Axios/Axios';
import PostUser from './Axios/PostUser';

// class Demo extends Component {
//   render() {
//     return (
//       <>
//         <h1>Demo</h1>
//       </>
//     )
//   }
// }

// class Hello extends Component {
//   render() {
//     return (
//       <>
//         <h3>Hello</h3>
//       </>
//     )
//   }
// }

// class World extends Component {
//   render() {
//     return (
//       <>
//         <h3>World</h3>
//       </>
//     )
//   }
// }

class HelloWorld extends Component {
  constructor() {
    super();
    this.name = "Demo Name";

    this.state = {
      first_name: "First Name",
      count: 0,
      count2: 0,
      fruits: ["banana", "apple", "mango"]  //Array
    }
    this.incrementCounter = this.incrementCounter.bind(this);
  }

    arrayDemo = () => {
    //add
    const fruit = ["orange"];
    fruit.push("Kiwi");
    const newFruits = fruit.concat("Apples");
    console.log("fruit", fruit);
    console.log("newFruits", newFruits);
    
    //remove
    newFruits.splice(0,1);
    console.log("newFruits", newFruits);
    const removeFruit = newFruits.filter((fruit, index) => {return index === 0});
    console.log("removeFruit has removed fruit, but didnt change the array", removeFruit);
    console.log("newFruits does changed", newFruits);
    
    //modify
    fruit[1] = "Water Melon"
    fruit[0] = "kiwi salad"
    const modifyFruit = newFruits.map((fruit) => {
      return fruit + " salad"
    });
    console.log("modifyFruit", modifyFruit);

    const modify2Fruit = newFruits.map((fruit, index) => {
    if (index === 0) {
      return "kiwiz"
      }
    return fruit
    });
    console.log("modify2Fruit", modify2Fruit);
    console.log("newFruits", newFruits);
  }

    objectsDemo = () => {
      const student = {
        name: 'qwerty'
      }

      //mutable
      student.name = 'Qwerty';
      console.log("student", student);
      
      //immutable
      const newStudent = {
        ...student,
        name: 'modified name',
        roll: 25
      }

      console.log("newStudent", newStudent);
      console.log("student", student);
  }

    incrementCounter() {
      //storing count from state into variable
      let counts = this.state.count;
      this.setState({
        count: ++counts,
        count2: 2 + counts
      });
    }

    getName() {
        return "Qwerty";
    }

  render() {
    return (
      <>

      <PostUser/>
      
        <span>
            {/* <Demo />
            <Hello />
            <World /> */}
        </span>

        <section>
        <h3 className="ui horizontal divider header">
          <i className="tag icon"></i>
          Power Plugin
        </h3>
          <PowerPlugin />
          <br/>        
        </section>

        <section>
        <h3 className="ui horizontal divider header">
          <i className="tag icon"></i>
          Axios List
        </h3>
            <AxiosList/>
        <br/>
        </section>
        
        <section>
        <h3 className="ui horizontal divider header">
          <i className="tag icon"></i>
          State
        </h3>
          State: It provides us to pass / store the data dynamically,<br/>
          and we can render that in UI page
        </section>
        
        <section>
            You can only use expression statements in here, <br/>
            no if / for loop statements wrok inside return. <br/><br/>
            <b>In class before render() you can use : </b><br/>
            1. constructor() - super()<br/>
            2. methods <br/>
            3. function <br/>
        </section>
        
        <section>
            <hr/><br />
            Js calculation: { 2 + 2 } <br/>
            JSX constructor function call: {this.name} <br/>
            JSX state call: {this.state.first_name} <br/>
            JSX method call: {this.getName()}  <br/>
            <hr/><br />
            {this.state.count}
            <div>
              <button
              onClick={this.incrementCounter}
              >
                Add Counter
              </button>
            </div>
            <br/>
        </section>

        <section>
          <h3 className="ui horizontal divider header">
            <i className="tag icon"></i>
            Props
          </h3>
            For passing property of state in one component into another component, we use props <br/>
            We can not only pass the state from one component to another, we can even pass function also, which can modify state, using props. <br/>
            Props are read only. Props can not modify component, here "count" belongs to Demo.js from "state" we are getting the data and passing it as a "props" to counter.js file <br/>
            "counts2" is just called, props is not changing. It is just calling data. <br/>
            It is uni-directional, passes in one direction only. I hv any kind of bug, then we can find that only in Main component file, here its Demo.js, cuz here only state belongs so the bug/error will be here in demo.js file only. <br/>

          <Counter
          counts2={this.state.count2} 
          incrementCounter={this.incrementCounter}
          />
        </section>
       
        <section>
          <hr/><br />
          Array Example
          {this.state.fruits.map((fruit, index) => {
              return (
                <ol className="steps" key={Math.random()}>
                  <li key={index}>
                      { fruit }
                  </li>
                </ol>
              )
            })
          }
        </section>
        
        <section>
        <h3 className="ui horizontal divider header">
          <i className="tag icon"></i>
          Array Demo
        </h3>
          <p>Immutable vs Mutable</p>

          <h4>Add Items:</h4>

          const fruit = ["orange"];<br/><br/>

          We can do this:<br/>
          fruit.push("Kiwi");<br/><br/>

          Better approach:<br/>
          const newFruits = fruit.concat("Apples");
          <br/><br/>

          console.log(fruit);<br/>
          console.log(newFruits);<br/><br/>
          
          <h4>Remove Items:</h4>
          newFruits.splice(0,1);<br /><br />

          Better Way:<br />
          const newFruit = newFruits.filter((fruit, index) = return index !== 0 );<br /><br />

          console.log(newFruit);<br />
          console.log(fruit);<br /><br />

          <h4>Modify Items:</h4>
                 fruit[1] = "Water Melon"
          <br /> fruit[0] = "kiwi salad"
          <br /> const modifyFruit = newFruits.map((fruit) = 
          <br />   return fruit + " salad"
          <br /> );
          <br /> console.log("modifyFruit", modifyFruit);
          <br />
          <br /> const modify2Fruit = newFruits.map((fruit, index) = 
          <br /> if (index === 0) 
          <br />   'return' "kiwiz"
          <br />
          <br /> 'return' 'fruit'
          <br /> );
          <br />
          <br /> console.log("modify2Fruit", modify2Fruit);
          <br /> console.log("newFruits", newFruits);
          {this.arrayDemo()}
          <br/>
          <br/>
        </section>
        
        <section>
        <h3 className="ui horizontal divider header">
          <i className="tag icon"></i>
          Objects Demo
        </h3>

        <br />  const student = 
        <br />  name: 'qwerty'
        <br />  

        <h3>Mutable</h3>
                student.name = 'Qwerty';
        <br />  console.log("student", student);
        <br />  
      
        <h3>Immutable</h3>
                  const newStudent = 
        <br />    ...student,
        <br />    name: 'modified name',
        <br />    roll: 25
        <br />  

        <br />  console.log("newStudent", newStudent);
        <br />  console.log("student", student);

          {this.objectsDemo()}
        <br />
        <br />
        </section>
        
        <section>
        <h3 className="ui horizontal divider header">
          <i className="tag icon"></i>
          Un-mounting Demo
        </h3>
          <ToggleBtn />
        </section>
        
      </>
    )
  }
}

export { HelloWorld };
